import {useRouteMatch} from "react-router-dom";
import {Route} from "react-router";
import {ZidOAuth} from "./ZidOAuth";
import {ZidOAuthCallback} from "./ZidOAuthCallback";

export const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route path={`${path}/oauth`} exact>
        <ZidOAuth />
      </Route>
      <Route path={`${path}/oauth/callback`}>
        <ZidOAuthCallback />
      </Route>
    </>
  )
}